import { useEffect, useState } from "react";
import { Chart, PieSeries } from "@devexpress/dx-react-chart-material-ui";
import { Animation } from "@devexpress/dx-react-chart";
import { Palette } from "@devexpress/dx-react-chart";

import { useHttpClient } from "../../../shared/hooks/httpHook";
import { ModalError } from "../../../shared/components/UIElements/ModalError";
import { LoadingSpinnerOverlayRegular } from "../../../shared/components/UIElements/LoadingSpinnerOverlayRegular";
import { addThousandSeparator } from "../../../shared/util/addThousandSeparator";
import { generateFormattedDateFromTimestamp } from "../../../shared/util/generateFormattedDateFromTimestamp";
import { getMonthNameAndYear } from "../../../shared/util/getMonthNameAndYear";
import { sliceLongString } from "../../../shared/util/sliceLongString";
import {
  getKanban,
  populateKanbanItem,
} from "../../../sales/api/salesFunnelAPI";
import {
  AuthContextProps,
  SettingsContextProps,
  SalePopCustData,
  KanbanFilledData,
  SettingsContextData,
  NotePopCustData,
  SaleData,
  TimePeriodData,
} from "../../../shared/data/types";

import "./HomeDashboard.scss";

interface HomeDashboardNextSchedulesItemProps {
  item: NotePopCustData;
  auth: AuthContextProps;
  fetchId: string;
  kanbanData: KanbanFilledData;
  settingsCtx: SettingsContextData;
  type:
    | "SALES"
    | "PROJECT"
    | "INSTALLATION"
    | "AFTER_SALES"
    | "PRE_SALES"
    | "ADMINISTRATIVE";
  setType: React.Dispatch<
    React.SetStateAction<
      | "SALES"
      | "PROJECT"
      | "INSTALLATION"
      | "AFTER_SALES"
      | "PRE_SALES"
      | "ADMINISTRATIVE"
    >
  >;
  setLoadedData: React.Dispatch<React.SetStateAction<KanbanFilledData>>;
  setActiveItem: React.Dispatch<React.SetStateAction<string>>;
  setActiveNote: React.Dispatch<React.SetStateAction<string>>;
}

export const HomeDashboardNextSchedulesItem = (
  props: HomeDashboardNextSchedulesItemProps
) => {
  const {
    item,
    auth,
    fetchId,
    kanbanData,
    settingsCtx,
    setLoadedData,
    setActiveItem,
    setActiveNote,
    setType,
    type,
  } = props;
  const { error, sendRequest, clearError, isLoading } = useHttpClient();
  const itemSale = item.sale as SaleData;
  const itemTypeTxt =
    itemSale.type === "SALES"
      ? "VENDA"
      : itemSale.type === "PROJECT"
      ? "PROJETO"
      : itemSale.type === "INSTALLATION"
      ? "OBRA"
      : itemSale.type === "AFTER_SALES"
      ? "PÓS-VEN."
      : itemSale.type === "PRE_SALES"
      ? "PRÉ-VEN."
      : "ADM.";

  const handlePopulateAndActivateItem = () => {
    const noteSale = item.sale as SaleData;

    if (!kanbanData || noteSale.type !== type) {
      getKanban({
        sendRequest,
        auth,
        fetchId: auth.type === "MANAGER" ? auth.managerId : auth?.userId,
        type: noteSale.type,
        searchValue: "",
        searchValueField: "name_sale",
        filter1Active: false,
        filter1Value: {} as TimePeriodData,
        setKanbanData: setLoadedData,
        hidration: true,
        multiplier: 0,
        kanbanData,
      }).then(() => {
        populateKanbanItem({
          sendRequest,
          auth,
          setKanbanData: setLoadedData,
          itemId: noteSale?._id,
          type,
        }).then(() => {
          setActiveNote(item._id);
          setType(noteSale.type);
          setActiveItem(noteSale._id as string);
        });
      });
    } else {
      const kbNoteSale = kanbanData?.items?.find((item) => {
        return item._id === noteSale._id;
      });

      if (!kbNoteSale?.customer?.user || !kbNoteSale?.registryDate) {
        populateKanbanItem({
          sendRequest,
          auth,
          setKanbanData: setLoadedData,
          itemId: noteSale?._id,
          type,
        }).then(() => {
          setActiveNote(item._id);
          setType(noteSale.type);
          setActiveItem(noteSale._id as string);
        });
      } else {
        setActiveNote(item._id);
        setType(noteSale.type);
        setActiveItem(noteSale._id as string);
      }
    }
  };

  return (
    <div className="dashboard-item__list-item-container">
      {isLoading && <LoadingSpinnerOverlayRegular size={25} />}
      <div
        onClick={handlePopulateAndActivateItem}
        className="dashboard-item__list-item dashboard-item__list-item--5-col-fin"
      >
        <p className="dashboard-item__list-item-name">{item.customer?.name}</p>
        <p className="dashboard-item__list-item-amount">
          {item.type || "Sem Tipo"}
        </p>
        <p className="dashboard-item__list-item-name dashboard-item__list-item-name--vanish">
          {sliceLongString(item?.content || "", 35) || "Sem Conteúdo"}
        </p>
        <span
          className={`dashboard-item__list-item-status ${
            itemSale.type === "SALES"
              ? "dashboard-item__list-item-status--neutral"
              : itemSale.type === "PROJECT"
              ? "dashboard-item__list-item-status--pos"
              : itemSale.type === "INSTALLATION"
              ? "dashboard-item__list-item-status--pos-2"
              : itemSale.type === "AFTER_SALES"
              ? "dashboard-item__list-item-status--pos-3"
              : itemSale.type === "PRE_SALES"
              ? "dashboard-item__list-item-status--pos-4"
              : "dashboard-item__list-item-status--pos-5"
          }`}
        >
          {itemTypeTxt}
        </span>
        <p className="dashboard-item__list-item-date">
          {generateFormattedDateFromTimestamp(item.notificationTimestamp)}
        </p>
      </div>
    </div>
  );
};
